import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import LoadingIndicator from "../../../../setup/Loader/LoaderIndicator";

const DeleteChildInfo = ({
  showModal,
  closeModal,
  getLangTranslation,
  handleContinue,
  loader,
  setReason,
  reason,
}) => {
  const { kidDevicesList, kidList, selectedKidId } = useSelector(
    ({ dashboard }) => dashboard
  );
  const [kidData, setKidData] = useState(null);

  useEffect(() => {
    if (kidList?.length > 0 && selectedKidId) {
      const pickedKidData = kidList.find((item) => item.ID === selectedKidId);

      setKidData(pickedKidData);
    }
  }, [kidList]);


  return (
    <>
      <Modal
        show={showModal}
        size="sm"
        className="custom-modal blur-bg"
        centered
      >
        <Modal.Header>
          <div className="border-0 pb-0 d-flex justify-content-between w-100">
            <h6 className="modal-title text-blue-900">
              {getLangTranslation("DELETE_CHILD", "Delete child")}
            </h6>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
        </Modal.Header>
        <Modal.Body className="py-3 px-4">
          <>
            {kidDevicesList?.length > 0 ? (
              <p className="text-danger fs-7">
                {`Sorry, you cannot delete ${kidData?.childName}'s profile as he/she has devices connected to his/her profile. Please remove all the devices connected to his/her profile first`}
              </p>
            ) : (
              <>
                <div className="mb-6">
                  <label htmlFor="DELETE_PROFILE" className="form-label">
                    {getLangTranslation(
                      "YOU_CAN_DELETE_CHILD_PROFILE",
                      "You can delete $CHILD_NAME's profile"
                    )?.replace("$CHILD_NAME", kidData?.childName)}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="DELETE_PROFILE"
                    placeholder="Enter reason to delete child profile"
                    name="DELETE_PROFILE"
                    onChange={(e) =>
                      setReason({
                        error: "",
                        value: e.target.value,
                      })
                    }
                  />
                  {reason?.error && (
                    <div className="text-danger my-2">{reason?.error}</div>
                  )}
                </div>
              </>
            )}

            <button
              className="btn btn-primary w-100 my-3"
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                if (kidDevicesList?.length > 0) {
                  closeModal();
                } else {
                  handleContinue();
                }
              }}
            >
              {loader ? (
                <div className="">
                  <LoadingIndicator height={20} width={100} color="#FFF" />
                </div>
              ) : (
                <span className="btn-upper-case">
                  {getLangTranslation("CONTINUE", "Continue")}
                </span>
              )}
            </button>
          </>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DeleteChildInfo;
